import ClusterIcon from 'components/ClusterIcon';
import DefinitionTooltip from 'components/DefinitionTooltip';
import { tooltips } from '@/copy';

const clusters = tooltips.clusters.reduce(
    (acc, { value, icon, label, definition }) => {
        acc[value] = {
            icon: icon || value,
            title: label || value,
            body: definition,
        };
        return acc;
    },
    {},
);

const CLUSTER_SOURCE_KEY = {
    popularity: 'clusterPopularity',
    google: 'cluster',
    tiktok: 'clusterTikTok',
    instagram: 'clusterInstagram',
};

function ClusterTooltip({ cluster, dataSource, ...props }) {
    const { title, body, icon } = clusters[cluster];
    const src = dataSource ? tooltips[CLUSTER_SOURCE_KEY[dataSource]] : null;
    return (
        <DefinitionTooltip
            icon={<ClusterIcon cluster={icon} />}
            title={title}
            body={body}
            source={src?.source}
            sourceDataType={src?.sourceDataType}
            mixpanelMeta={{ contentKey: cluster }}
            {...props}
        />
    );
}

export default ClusterTooltip;
